var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveWorkspace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Usu\\u0144_stron\\u0119_1",
    "data-name": "Usu\\u0144 stron\\u0119 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4828",
    "data-name": "Group 4828",
    transform: "translate(-613.333 -879.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4826",
    "data-name": "Group 4826"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(613.333 879.757)",
    fill: "red"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "delete",
    d: "M.969,15.731V3.921h11.81v11.81a1.913,1.913,0,0,1-.577,1.407,1.864,1.864,0,0,1-1.361.577H2.952a1.913,1.913,0,0,1-1.407-.577A1.917,1.917,0,0,1,.969,15.731ZM13.793.969V2.952H0V.969H3.46L4.429,0H9.365l.969.969Z",
    transform: "translate(11 9)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveWorkspace);
export default __webpack_public_path__ + "static/media/remove-workspace.09c54c4d549fb93c4e378f5c26c6b829.svg";
export { ForwardRef as ReactComponent };